export const COMPLETE_MAIN_TEXT = {
  boardCreate: `의료팀에게 질문을\n 전달하였습니다`,
  boardUpdate: '질문이 수정되었습니다',
}

export const COMPLETE_SUB_TEXT =
  '24시간 내로 답변을 받아볼 수 있습니다.\n답변이 완료되면 알림을 보내드리겠습니다.'
